import React from 'react';
import { CheckIcon } from 'lucide-react';
export function IdentificacionSection() {
  const items = ['Trabajas muchas horas', 'Tu día se llena de tareas', 'Respondes mensajes todo el tiempo', 'Terminas agotado'];
  return <section className="bg-white py-16 md:py-24 px-4" data-id="element-95">
      <div className="max-w-4xl mx-auto" data-id="element-96">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8 text-center md:text-left" data-id="element-97">
          ¿Te pasa esto?
        </h2>

        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-98">
          <ul className="space-y-4" data-id="element-99">
            {items.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-100">
                <CheckIcon className="w-6 h-6 text-[#FF6B00] flex-shrink-0 mt-0.5" data-id="element-101" />
                <span className="text-xl text-gray-800" data-id="element-102">{item}</span>
              </li>)}
          </ul>

          <div className="space-y-4 text-xl text-gray-700 bg-gray-50 p-8 rounded-2xl border border-gray-100" data-id="element-103">
            <p data-id="element-104">Pero tu negocio no crece como debería.</p>
            <br data-id="element-105" />
            <p data-id="element-106">No es falta de talento.</p>
            <br data-id="element-107" />
            <p className="font-bold text-gray-900" data-id="element-108">Son las fugas.</p>
          </div>
        </div>
      </div>
    </section>;
}